module.exports = __webpack_public_path__ + "static/footerBG.bb264c75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footerBG.jpg
// module id = 837
// module chunks = 114276838955818